<script setup lang="ts">
  const props = defineProps<{
    modelValue: boolean;
    title: string;
    text?: string;
    buttonText: string;
  }>();

  const emit = defineEmits(['update:modelValue', 'confirm', 'close']);

  function closeModal() {
    emit('update:modelValue', false);
    emit('close');
  }

  function confirmAction() {
    emit('confirm');
  }
</script>

<template>
  <div v-if="props.modelValue" class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40">
    <div class="w-[300px] max-w-full rounded bg-white p-6">
      <h2 class="mb-2 text-lg font-bold">{{ props.title }}</h2>
      <p class="mb-4 text-sm text-gray-700">
        {{ props.text }}
      </p>
      <div class="flex justify-end gap-2">
        <button class="rounded border border-gray-400 px-3 py-1 text-gray-700" @click="closeModal">Cancel</button>
        <button class="rounded bg-red-600 px-3 py-1 text-white" @click="confirmAction">
          {{ props.buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>
